import { ImageField, StringField, LinkField } from "../../../types/types";
import { HeroBannerFields, HeroBannerProps } from "../types/HeroBanner.types";

export class HeroBannerModel {
  private readonly fields?: HeroBannerFields;
  constructor(props: HeroBannerProps) {
    this.fields = props.fields;
  }

  get description(): StringField | undefined {
    return this.fields?.description;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get imageMobile(): ImageField | undefined {
    return this.fields?.imageMobile;
  }

  get primaryLink(): LinkField | undefined {
    return this.fields?.link1;
  }

  get secondaryLink(): LinkField | undefined {
    return this.fields?.link2;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }
}
